export const ListQueryKey = 'routes';
export const DetailQueryKey = 'route';

export const Urls = {
  selectUrl: '/privileges/route/list',
  updateUrl: '/privileges/route/update',
  deleteUrl: '/privileges/route/delete',
  createUrl: '/privileges/route/create',
  detailUrl: '/privileges/route/detail',
};
